/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { Fade } from '@material-ui/core';
import PropTypes from 'prop-types';
import axios from 'axios';
import { canI, RbacAction } from '../../../services/provider/rbacProvider';
import ToolbarMenu from '../../../base/components/action-menu/toolbar-menu';
import { SmallButton } from '../../../base/components/ra/buttons';
import { BET_STATUS_TO_VIEW_REPLAY } from '../../../constant';

export const ActionMenu = (props) => {
  const { record, resource, permissions } = props;

  const hasEdit = record?.betStatus === 'PENDING' && canI(RbacAction.UPDATE, resource, permissions);

  const [betReplayUrl, setBetReplayUrl] = useState('');

  const getReplayUrlFromServer = async ({ betId, brandId }) => {
    try {
      const { data: replayDetailUrl } = await axios.get(`api/bet/${betId}/replay-url?brandId=${brandId}`);
      setBetReplayUrl(replayDetailUrl);
    } catch (error) {
      console.debug('Error', error);
    }
  };

  useEffect(() => {
    const { brandId, id: betId, betStatus } = record || {};

    if (brandId && betId && BET_STATUS_TO_VIEW_REPLAY.includes(betStatus)) {
      getReplayUrlFromServer({
        brandId,
        betId,
      });
    }
  }, [record]);

  return (
    <ToolbarMenu {...props} hasEdit={hasEdit}>
      {betReplayUrl && (
        <Fade in timeout={200}>
          <SmallButton
            label="ra.action.replayBet"
            onClick={() => window.open(betReplayUrl, '_blank')}
            startIcon={<PlayArrowIcon />}
          />
        </Fade>
      )}
    </ToolbarMenu>
  );
};

ActionMenu.propTypes = {
  record: PropTypes.object,
};

ActionMenu.defaultProps = {
  record: {},
};
